export default __webpack_public_path__ + "static/media/campers.eb8e2611.svg";